// import { getColor } from "@/config/ui-colors";
import { cn, ListBox, Popover, Surface } from "@heroui/react";
import { ChevronDown, X } from "lucide-react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const MultiSelectFilterSurface = ({
  label,
  defaultLabel,
  filterKey,
  options = [],
  triggerClassName,
}) => {
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedKeys = searchParams.getAll(filterKey);
  const selectedSet = new Set(selectedKeys);
  const count = selectedSet.size;

  const triggerLabel =
    count === 0
      ? (defaultLabel ?? `All ${label ?? ""}s`.trim())
      : count === 1
        ? (options.find((o) => selectedSet.has(String(o.value)))?.label ?? `${count} selected`)
        : `Multiple (${count})`;

  const handleSelectionChange = (keys) => {
    const next = [...keys];
    setSearchParams((prev) => {
      prev.delete(filterKey);
      next.forEach((k) => prev.append(filterKey, k));
      return prev;
    });
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSearchParams((prev) => {
      prev.delete(filterKey);
      return prev;
    });
  };

  return (
    <Popover isOpen={open} onOpenChange={setOpen} placement="bottom-start">
      <Popover.Trigger asChild>
        <Surface
          className={cn(
            "px-3 pb-2 pt-3 h-full rounded-lg border border-muted/30 min-w-30 cursor-pointer select-none",
            triggerClassName,
          )}
        >
          {label && (
            <span className="text-[11px] mb-2 font-medium text-muted leading-none block">
              {label}
            </span>
          )}

          <div className="flex items-center gap-1">
            <span
              className={cn(
                "text-sm font-medium flex-1 leading-none",
                count > 0 ? "text-foreground" : "text-muted",
              )}
            >
              {triggerLabel}
            </span>

            <div className="flex items-center gap-0.5">
              {count > 0 && (
                <button
                  onPointerDown={(e) => e.stopPropagation()}
                  onClick={handleClear}
                  className="text-default-400 hover:text-foreground transition-colors p-0.5 rounded"
                >
                  <X size={11} />
                </button>
              )}
              <ChevronDown
                size={13}
                className={cn(
                  "text-default-400 transition-transform duration-200",
                  open && "rotate-180",
                )}
              />
            </div>
          </div>
        </Surface>
      </Popover.Trigger>

      <Popover.Content className="p-1 min-w-44">
        <ListBox
          selectionMode="multiple"
          selectedKeys={selectedSet}
          onSelectionChange={handleSelectionChange}
        >
          {options.map((opt) => (
            <ListBox.Item
              key={String(opt.value)}
              id={String(opt.value)}
              textValue={opt.label}
            >
              <div className="flex items-center gap-2 w-full">
                {/* {opt.color && (
                  <span
                    className={cn(
                      "size-2 rounded-full shrink-0",
                      getColor(opt.color, "dot"),
                    )}
                  />
                )} */}
                <span className="flex-1 text-sm">{opt.label}</span>
                <ListBox.ItemIndicator />
              </div>
            </ListBox.Item>
          ))}
        </ListBox>
      </Popover.Content>
    </Popover>
  );
};

export default MultiSelectFilterSurface;